import React from "react";
import Icon from '../../../components/AppIcon';


const StatTile = ({ icon: Icon, label, value, style }) => {
  return (
    <div
      className="relative overflow-hidden rounded-xl p-4 text-white shadow-md"
      style={{ minWidth: 0, ...style }}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-medium text-white/80 uppercase tracking-wide mb-1">
            {label}
          </p>
          <p className="text-3xl font-bold leading-none">{value}</p>
        </div>
        <div className="bg-white/20 rounded-lg p-2 flex-shrink-0">
          <Icon size={20} className="text-white" />
        </div>
      </div>
      {/* decorative circle */}
      <div className="absolute -bottom-3 -right-3 w-16 h-16 rounded-full bg-white/10 pointer-events-none" />
    </div>
  );
};

export default StatTile;
